export const COMMENTS = 
[
    {
        id: 0,
        dishId: 0,
        rating: 5,
        comment: "Посылает кого-нибудь на небеса, я бы хотел, чтобы моя свекровь съела это! :)",
        author: "Анна Борисовна",
        date: "2020-10-16T17:57:28.556094Z"
    },
    {
        id: 1,
        dishId: 0,
        rating: 4,
        comment: "It looked absolutely fantastic and our guests were very impressed. My dad couldn't believe it was a cake - he thought it looked like a model. Thank you so much ...",
        author: "Ahmad Bay 80th Birthday",
        date: "2014-09-05T17:57:28.556094Z"
    },
    {
        id: 2,
        dishId: 0,
        rating: 3,
        comment: "Jen what can I say omg our cake was unreal I cried when I saw it thank you so much xxxxxxx",
        author: "Mark & Jenn - Wedding Cake",
        date: "2015-02-13T17:57:28.556094Z"
    },
    {
        id: 3,
        dishId: 0,
        rating: 4,
        comment: "..... OMG The cake was amazing everyone said how nice it was, it tasted beautiful there was hardly any left lol!",
        author: "Lorna & Gary - Wedding Cake",
        date: "2013-12-02T17:57:28.556094Z"
    },
    {
        id: 4,
        dishId: 0,
        rating: 2,
        comment: "Thank you so much for the amazing cake my son loved it. It was perfect and tasted really delicious. Everything about it was just perfect.",
        author: "Susan Jowers - 30th Birthday",
        date: "2011-12-02T17:57:28.556094Z"
    },
    {
        id: 5,
        dishId: 1,
        rating: 5,
        comment: "Rahmat juda ham mazali ekan!",
        author: "John Lemon",
        date: "2012-10-16T17:57:28.556094Z"
    },
    {
        id: 6,
        dishId: 1,
        rating: 4,
        comment: "شكرا جزيلا على الكعكة التي أحبها الجميع!",
        author: "Muhammad & Leyla - Engagement Cake",
        date: "2014-09-05T17:57:28.556094Z"
    },
    {
        id: 7,
        dishId: 1,
        rating: 3,
        comment: "Got home fine with it all in tact! Absolutely love it - can't stop looking at it!",
        author: "Rayhona 23rd Birthday",
        date: "2015-02-13T17:57:28.556094Z"
    },
    {
        id: 8,
        dishId: 1,
        rating: 4,
        comment: "Annabell loved the cake she was over the moon thank you so much again!",
        author: "Helen - 18th Birthday",
        date: "2013-12-02T17:57:28.556094Z"
    },
    {
        id: 9,
        dishId: 1,
        rating: 2,
        comment: "I just wanted to let you know that the cake was amazing and all the guests loved it .... we will definitely be recommending her services and will use her in the future.",
        author: "EMEA Lifestyle Concierge Service",
        date: "2011-12-02T17:57:28.556094Z"
    },
    {
        id: 10,
        dishId: 2,
        rating: 5,
        comment: "Just a quick thank you for Fatima's cake and cupcakes. She said: I don't like the cake, Mum... I love it!.",
        author: "Aziza",
        date: "2012-10-16T17:57:28.556094Z"
    },
    {
        id: 11,
        dishId: 2,
        rating: 4,
        comment: "Thanks so much for the amazing cake, it was brilliant!",
        author: "Paul",
        date: "2014-09-05T17:57:28.556094Z"
    },
    {
        id: 12,
        dishId: 2,
        rating: 3,
        comment: "Just to say thanks very much for our wonderful cake - we were very pleased with both how it looked and tasted!",
        author: "Paul & Lucy - Wedding Cake",
        date: "2015-02-13T17:57:28.556094Z"
    },
    {
        id: 13,
        dishId: 2,
        rating: 4,
        comment: "Wow wow wow!!!!! What can I say?! There are no words that come close to saying how happy we were with our perfect wedding cake!",
        author: "Karla & Chris - Wedding Cake",
        date: "2013-12-02T17:57:28.556094Z"
    },
    {
        id: 14,
        dishId: 2,
        rating: 2,
        comment: "Just wanted to say a massive thank you for the cake!",
        author: "Mansur",
        date: "2011-12-02T17:57:28.556094Z"
    },
    {
        id: 15,
        dishId: 3,
        rating: 5,
        comment: "	I just wanted to tell you how pleased we are with the cake that you made for our joint christening and birthday celebration.",
        author: "John Martin",
        date: "2012-10-16T17:57:28.556094Z"
    },
    {
        id: 16,
        dishId: 3,
        rating: 4,
        comment: "Alison was sooooooooo pleased with her cake! We all thought it was fantastic and thoroughly enjoyed a slice (or 2) ;) Thank you!",
        author: "Paul & Lisa",
        date: "2014-09-05T17:57:28.556094Z"
    },
    {
        id: 17,
        dishId: 3,
        rating: 3,
        comment: "Eat it, fantastic and thoroughly enjoyed!",
        author: "Lisa - Christening & Birthday",
        date: "2015-02-13T17:57:28.556094Z"
    },
    {
        id: 18,
        dishId: 3,
        rating: 4,
        comment: "Alijon was sooooooooo pleased with her cake! !",
        author: "Ahmad aka",
        date: "2013-12-02T17:57:28.556094Z"
    },
    {
        id: 19,
        dishId: 3,
        rating: 2,
        comment: "Just wanted to say a huge thank you for the cake you did for my Dads surprise 50th.",
        author: "Tanya",
        date: "2011-12-02T17:57:28.556094Z"
    }
];